import "../../../assets/scss/components/sections/home/save-money.scss";
import { Button, Col, Container, Form, Image, Row } from "react-bootstrap";
import Heading from "../../templates/heading";
import { useState } from "react";

import timeSavedIcon from "../../../assets/images/home/time-saved.svg";
import valueOfTimeIcon from "../../../assets/images/home/value-of-time.svg";

import shape1 from "../../../assets/images/home/shape-2.svg";
import shape2 from "../../../assets/images/home/shape-3.svg";

const formatNumber = (value) => {
  if (value >= 1000) {
    return (value / 1000).toFixed(1) + "k";
  }
  return value;
};

const SaveMoney = () => {
  const [sliderValue, setSliderValue] = useState(30);
  const [multiplier, setMultiplier] = useState(80);
  const [saveTime, setSaveTime] = useState(sliderValue * 2);
  const [valueOfTime, setValueOfTime] = useState(saveTime * multiplier);
  const [ROI, setROI] = useState(valueOfTime / 30);

  const handleSliderChange = (e) => {
    const value = Number(e.target.value);
    setSliderValue(value);
    const calculatedSaveTime = value * 2;
    setSaveTime(calculatedSaveTime);

    const calculatedValueOfTime = calculatedSaveTime * multiplier;
    setValueOfTime(calculatedValueOfTime);

    const calculatedROI = Math.round(calculatedValueOfTime / 30);
    setROI(calculatedROI);
  };

  const handleSetMultiplier = (factor) => {
    setMultiplier(factor);

    const calculatedValueOfTime = saveTime * factor;
    setValueOfTime(calculatedValueOfTime);

    const calculatedROI = Math.round(calculatedValueOfTime / 30);
    setROI(calculatedROI);
  };

  return (
    <div className="save-money-section">
      <Container>
        <div className="save-money">
          <Heading
            heading="See How Much Time and Money You Can Save"
            text="Select your career level and see the  benefits Resumly brings to your job search"
          />
          <div className="save-money-box">
            <h6 className="heading-6 mb-3">Career Level</h6>
            <div className="save-money-btns">
              <Button
                variant={multiplier === 50 ? "active" : "save-money"}
                onClick={() => handleSetMultiplier(50)}
                className="d-md-inline-block d-none"
              >
                Early Career
              </Button>
              <Button
                variant={multiplier === 50 ? "active" : "save-money"}
                onClick={() => handleSetMultiplier(50)}
                className="d-inline-block d-md-none"
              >
                Early
              </Button>
              <Button
                variant={multiplier === 80 ? "active" : "save-money"}
                onClick={() => handleSetMultiplier(80)}
                className="d-md-inline-block d-none"
              >
                Mid-Career
              </Button>
              <Button
                variant={multiplier === 80 ? "active" : "save-money"}
                onClick={() => handleSetMultiplier(80)}
                className="d-inline-block d-md-none"
              >
                Mid
              </Button>
              <Button
                variant={multiplier === 120 ? "active" : "save-money"}
                onClick={() => handleSetMultiplier(120)}
                className="d-md-inline-block d-none"
              >
                Professional
              </Button>
              <Button
                variant={multiplier === 120 ? "active" : "save-money"}
                onClick={() => handleSetMultiplier(120)}
                className="d-inline-block d-md-none"
              >
                Professional
              </Button>
            </div>
            <h6 className="heading-6 mb-4">
              Number of Jobs You Plan to Apply in a Month:
            </h6>
            <div
              style={{ position: "relative", width: "100%" }}
              className="range-slider"
            >
              <Form.Range
                min={0}
                max={100}
                value={sliderValue}
                onChange={handleSliderChange}
              />

              <div
                style={{
                  left: `calc(${sliderValue}% - ${sliderValue === 0
                    ? "5px"
                    : sliderValue === 100
                      ? "35px"
                      : "15px"
                    })`,
                }}
                className="track-tooltip"
              >
                {sliderValue}
              </div>
            </div>
            <div className="values-box">
              <Row className="justify-content-center">
                <Col xs={6}>
                  <div className="box-content">
                    <div className="icon">
                      <Image src={timeSavedIcon} />
                    </div>
                    <div className="text">
                      <h6 className="paragraph-smaller-medium">TIME SAVED</h6>
                      <h6 className="heading-6">{saveTime}</h6>
                    </div>
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="box-content">
                    <div className="icon">
                      <Image src={valueOfTimeIcon} />
                    </div>
                    <div className="text">
                      <h6 className="paragraph-smaller-medium">
                        VALUE OF TIME
                      </h6>
                      <h6 className="heading-6">
                        ${formatNumber(valueOfTime)}
                      </h6>
                    </div>
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="roi-text">
                    <h6 className="heading-6-medium">Your ROI</h6>
                    <h1 className="heading-1">{ROI}X</h1>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="shape-1 shape">
            <Image src={shape1} />
          </div>
          <div className="shape-2 shape">
            <Image src={shape2} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SaveMoney;
